import type { TractorWithAxlesResponse } from '@contracts/tractor/TractorWithAxlesResponse';
import type { Client } from '@src/clients/domain/Client';
import { useNavigateBack } from '@src/common/hooks/useNavigateBack';
import { useToast } from '@src/common/hooks/useToast';
import { ClientsNavigation } from '@src/routing/ClientsNavigation';
import { TractorPageContent } from '@src/tractor/TractorPageContent';
import { useTranslation } from 'react-i18next';

import { useUpdateTractor } from './hooks/useUpdateTractor';

type Props = {
  client: Client;
  tractor: TractorWithAxlesResponse;
};

export const EditTractorPage = ({ client, tractor }: Props) => {
  const { t } = useTranslation();
  const { goBack } = useNavigateBack({
    defaultPath: ClientsNavigation.get.url(client.id, 3),
  });

  const { showSuccessToast, showErrorToast } = useToast();

  const { updateTractor, isLoading } = useUpdateTractor({
    clientId: client.id,
    tractor,
    onSuccess: (_) => {
      showSuccessToast(t('updateTractor.success'));
      goBack();
    },
    onError: () => {
      showErrorToast(t('updateTractor.error'));
    },
  });

  return (
    <TractorPageContent
      client={client}
      onSubmit={updateTractor}
      onBack={goBack}
      onCancel={goBack}
      isLoading={isLoading}
      prefillData={tractor}
    />
  );
};
